export const CLIENT_ERROR = 'clientError';
export const GET_USER_AUTH = 'getUserAuth';
export const REVOKE_AUTH = 'revokeAuthorization';
export const IDIOM_REQUEST = 'idiomRequest';
export const JOIN_TOURNAMENT = 'joinTournament';
export const LEAVE_TOURNAMENT = 'leaveTournament';
export const PUSH_TOURNAMENT = 'pushTournament';
export const PROVIDER_CALENDAR = 'providerCalendar';
export const PROVIDER_CONFIG = 'providerConfig';
export const PUSH_KEY = 'pushKey';
export const SEND_KEY = 'sendKey';

export const AVAILABLE_IDIOMS = 'availableIdioms';
export const PROCESS_DIRECTIVE = 'processDirective';
export const TMX_DIRECTIVE = 'tmxDirective';
export const TMX_MESSAGE = 'tmxMessage';
export const TMX_ERROR = 'tmxError';

export const ADD_IDIOM = 'add idiom';
